import moment from "moment";


/**
 *
 * @param reservas Array con las fechas seleccionadas
 * @param bloqueadas Array con las fechas bloqueadas
 */

const bloquearFechas = function(reservas, maxNoches) {
    let consecutivos = 1;
    let bloqueadas = [];
    // Comprobar que no tienen límite de días consecutivos
    if (maxNoches !== 0 && maxNoches !== 99) {
        for (let idx = 0; idx < reservas.length - 1; idx++) {
            const actual = moment(reservas[idx]);
            const siguiente = moment(reservas[idx+1]);
            if(siguiente.diff(actual, 'days') === 1) consecutivos++;
            if(consecutivos === maxNoches) {
                bloqueadas.push(siguiente.add(1, 'days').format("YYYY-MM-DD"));
                bloqueadas.push(siguiente.add(-4, "days").format("YYYY-MM-DD"));
                bloqueadas.sort();
                consecutivos = 1;
            }
        }
    }
    return bloqueadas;
}


export const controlFechas  = {
    bloquearFechas
}